(function () {
    angular.module('tmx-app').factory('LocationService', [ 'tmxResource', 'lookupService', '$timeout', 'TMX_FINANCE_CONSTANTS', '$q', 'cacheStore', function ( tmxResource, lookupService, $timeout, TMX_FINANCE_CONSTANTS, $q, cacheStore) {
        var Locations = tmxResource("Location");
    // lookupService.getLocationTypes().then(function(lookups) {
    //   Locations.lookups = lookups;
    //   Locations.gridColumn[3].data = lookups;
    // });

        Locations.activeLocations;
        Locations.getActiveLocations = function () {
            var deferred = $q.defer();
            var cacheValues = cacheStore.get("ACTIVE_LOCATIONS");
            if (angular.isDefined(cacheValues) && cacheValues != null) {
                Locations.activeLocations= cacheValues;
                deferred.resolve(cacheValues);
            }
            else {
                tmxResource("Location").getByAction("Active", true).then(function(response){
                    if(response){
                        Locations.activeLocations = response;
                        cacheStore.set("ACTIVE_LOCATIONS",angular.copy(response));
                        deferred.resolve(response);
                    }
                    else {
                        deferred.reject('Unable to get user company configurations');
                    }
                });
            }
            return deferred.promise; 
        };

    
        Locations.getAllLocations = function () {
            return Locations.all();
        };
        Locations.getLovs = function () {
            return Locations.lov();
        };
        Locations.getLookupName = function (id) {
            var result = "N/A";
            if (!angular.isArray(Locations.lookups)) return;
            Locations.lookups.forEach(function (lookup) {
                if (lookup.LookupId == id) result = lookup.VisibleValue;
            });
            return result;
        }

        Locations.filterString = function (string) {
            string = string.replace(/<script>/g, '');
            string = string.replace(/<\/script>/g, '');
            return string;
        }

        Locations.getLovs().then(function (types) {
            Locations.parents = types.data;
            Locations.gridColumn[2].data = types.data;
            Locations.recievedLov = true;
        });
        Locations.getParentName = function (id) {
            var result = "N/A";
            Locations.parents.forEach(function (lookup) {
                if (lookup.HiddenValue == id) result = lookup.VisibleValue;
            });
            return result;
        }
        Locations.statusTemplate = function () {
            return "# if (EffectiveStartDate) { #" +
        "   #=EffectiveStartDate# " +
        "# } #";
        }
        Locations.isStatusActive = function (dataitem) {
            var currdate = new Date().toJSON();
            if (dataitem.EffectiveEndDate < currdate) return true;
            return false;
        }
        Locations.Status = function (dataitem) {
            var date = new Date().toJSON();
            if (dataitem.EffectiveEndDate < date) {
                return "Inactive";
            }
            else if (dataitem.EffectiveStartDate > date) {
                return "Pending";
            }
            else if (dataitem.EffectiveEndDate >= date && dataitem.EffectiveStartDate <= date) {
                return "Active";
            }
        };
        Locations.checkLocationCode = function (locationCode) {
            return Locations.getById("CheckLocation" + "/" + locationCode);
        }
        Locations.getActiveTopParent = function (gridData) {
            var deferred = $q.defer();
            $timeout(function () {
        // get top parent nodes
                var filteredData = gridData.Data.filter(function (obj) {
                    return obj.ParentLocationId == null;
                });
        //filteredData[0].hasChildren=true;
                var response = { data: filteredData, Data: filteredData, AggregateResults: null, Errors: null, Total: filteredData.length };
                deferred.resolve(response);

            });

            return deferred.promise;
        }
        Locations.getSpecificParentChild = function (gridData, parentId) {
            var deferred = $q.defer();
            $timeout(function () {
        // get childs
                var filteredData = gridData.Data.filter(function (obj) {
                    return obj.ParentLocationId == parentId;
                });
                var response = { data: filteredData, Data: filteredData, AggregateResults: null, Errors: null, Total: filteredData.length };
                deferred.resolve(response);

            });

            return deferred.promise;
        }
        Location.rowtemp = function (e) {

            function applyClassToRow() {
                // eslint-disable-next-line no-unused-vars
                var row = $("tr[data-uid='" + e.uid + "']")[0];
        //row.className+=' deleted-row';
            }
            if (Locations.isStatusActive(e))
                $timeout(applyClassToRow, 10);
            var template = "<md-button ng-disabled='!LocationCtrl.editPermission' class='tmx-primary-text' ng-disabled='!LocationCtrl.isStatusActive(dataItem) || !LocationCtrl.checkPermission(\"Private.Masterdata.Location\",\"Edit\")' ng-click='LocationCtrl.clickEdit(dataItem)' ng-bind='dataItem.LocationName'></md-button>";
            return template;
        }


    // Locations.status = [
    //       { HiddenValue: "active",
    //         VisibleValue: "Active"
    //       },
    //       { HiddenValue: "inactive",
    //         VisibleValue: "Inactive"
    //       },
    //       { HiddenValue: "pending",
    //         VisibleValue: "Pending"
    //       }
    //     ];
        Locations.gridColumn = [{
            field: "LocationName",
            title: "Name",
            type: "string",
            width: "40%",
      // template: "<span class=\"k-primary-column\" >#=LocationName#</span>"
            template: Location.rowtemp,//"<md-button class='tmx-primary-text' ng-class=\"{'deleted-row':LocationCtrl.isStatusActive(dataItem)}\" ng-disabled='LocationCtrl.isStatusActive(dataItem)' ng-click='LocationCtrl.clickEdit(dataItem)'> #= LocationName # </md-button>",
            headerTemplate: "<span  ng-class=\"{ 'filter-active' : LocationCtrl.isFiltered('LocationName')}\" >{{'Name' | translate}}<i class='fa fa-filter' ng-if='LocationCtrl.isFiltered(\"LocationName\")' ></i></span>"
        }, {
            field: "LocationCode",
            title: "Code",
            type: "string",
            headerTemplate: "<span  ng-class=\"{ 'filter-active' : LocationCtrl.isFiltered('LocationCode')}\" >{{'Code' | translate}}<i class='fa fa-filter' ng-if='LocationCtrl.isFiltered(\"LocationCode\")' ></i></span>"
        },
        // {
        //     field: "ParentLocationId",
        //     title: "Parent",
        //     type: "select",
        //     template: "{{LocationCtrl.getParentName(#=ParentLocationId#)}}",
        //     data: Locations.parents,
        //     isNumber: true,
        //     headerTemplate: "<span  ng-class=\"{ 'filter-active' : LocationCtrl.isFiltered('ParentLocationId')}\" >{{'Parent' | translate}}<i class='fa fa-filter' ng-if='LocationCtrl.isFiltered(\"ParentLocationId\")' ></i></span>"
        // },
        {
            field: "ParentLocationName",
            title: "Parent",
            type: "string",
            template: "{{LocationCtrl.getParentName(#=ParentLocationId#)}}",
            headerTemplate: "<span  ng-class=\"{ 'filter-active' : LocationCtrl.isFiltered('ParentLocationId')}\" >{{'Parent' | translate}}<i class='fa fa-filter' ng-if='LocationCtrl.isFiltered(\"ParentLocationId\")' ></i></span>"
        },
        // {
        //     field: "LocationTypeLkpId",
        //     title: "Type",
        //     type: "select",
        //     template: "{{LocationCtrl.getLookupName(#=LocationTypeLkpId#)}}",
        //     data: Locations.lookups,
        //     isNumber: true,
        //     headerTemplate: "<span  ng-class=\"{ 'filter-active' : LocationCtrl.isFiltered('LocationTypeLkpId')}\" style='padding-left:10px;'>{{'Type' | translate}}<i class='fa fa-filter' ng-if='LocationCtrl.isFiltered(\"LocationTypeLkpId\")' ></i></span>"
        // },
        {
            field: "LocationTypeName",
            title: "Type",
            type: "string",
            template: "{{LocationCtrl.getLookupName(#=LocationTypeLkpId#)}}",
            headerTemplate: "<span  ng-class=\"{ 'filter-active' : LocationCtrl.isFiltered('LocationTypeLkpId')}\" style='padding-left:10px;'>{{'Type' | translate}}<i class='fa fa-filter' ng-if='LocationCtrl.isFiltered(\"LocationTypeLkpId\")' ></i></span>"
        },
        {         
            template: "<md-menu flex='none' class='menu-list-item' md-offset='-20 60'><md-button class='menu-list-item-grid' ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons'>more_vert</md-icon></md-button><md-menu-content width='2' ><md-menu-item><md-button aria-label='del' class='tmxMin' ng-disabled='!LocationCtrl.viewPermission' ng-click='LocationCtrl.clickView(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>info</md-icon>Info</md-button></md-menu-item><md-menu-item><md-button ng-disabled='!LocationCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='LocationCtrl.clickParent(dataItem)'><md-icon class='md-accent material-icons menu-list-item'>add_circle</md-icon>Add Location Child</md-button></md-menu-item></md-menu-content></md-menu>"
        }
      // ,
      //   {
      //     field: "Status",
      //     title: "Status",
      //     type: "select",
      //     template: "<span class='status-\{\{LocationCtrl.Status(dataItem)\}\}' >\{\{LocationCtrl.Status(dataItem)\}\} </span>",
      //     data: Locations.status,
      //     headerTemplate:"<span  ng-class=\"{ 'filter-active' : LocationCtrl.isFiltered('Status')}\" >Status<i class='fa fa-filter' ng-if='LocationCtrl.isFiltered(\"Status\")' ></i></span>"
      // }
        ];
        Locations.columns = Locations.gridColumn;

    //initializing Lookup types from Tmx Finance Constant
        var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;


        var locationTypes = lookupService.getLocalLookupsByType(lkupType.LOCATION_TYPE);
        if (locationTypes) {
            Locations.lookups = locationTypes;
            Locations.gridColumn[3].data = locationTypes;
        }


        return Locations;
    }]);
})();
